var exports = {
  "nav": "nav__mHQXuz",
  "list": "list__2Gh7vS",
  "navLink": "navLink__HiENMw",
};

__webpack_require__.r(module.exports = exports);
